import { useUserCreate } from "@/store/User";
// import { useUserIdCreate } from '../../mobileApp/store/user-id-store';
import { localAESStorage } from "@/util/storage";
/**
 * [判断用户是否登陆]
 *
 * @export
 */
export const isLogin = () => {
  var _state_userState_userId;
  // const idState = useUserIdCreate.getState();
  const state = useUserCreate.getState();
  return !!((_state_userState_userId = state.userState.userId) === null || _state_userState_userId === void 0 ? void 0 : _state_userState_userId.trim() //|| !!idState.userIdState;
  );
};
/**
 * [判断设备]
 *
 * @export
 * @returns
 */
export const getDevice = () => {
  const UserAgent = navigator.userAgent;
  const isPc = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(UserAgent);
  if (isPc) {
    return "PC";
  } else {
    return "MOBILE";
  }
};
/**
 * [判断是否不同源]
 *
 * @export
 * @returns
 */
export function checkIsNotReferrer() {
  return window != window.parent;
}
// 判断操作系统
export function detectOS() {
  let result = "";
  const userAgent = navigator.userAgent;
  const isWindowsPhone = /Windows Phone/i.test(userAgent);
  const isAndroid = /Android/i.test(userAgent);
  const isiOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isWin = navigator.platform == "Win32" || navigator.platform == "Windows";
  const isMac = navigator.platform == "Mac68K" || navigator.platform == "MacPPC" || navigator.platform == "Macintosh" || navigator.platform == "MacIntel";
  const isUnix = navigator.platform == "X11" && !isWin && !isMac;
  const isLinux = String(navigator.platform).indexOf("Linux") > -1;
  if (isWindowsPhone) {
    result = "Windows Phone";
  } else if (isAndroid) {
    result = "Android";
  } else if (isiOS) {
    result = "iOS";
  } else if (isMac) {
    result = "Mac";
  } else if (isUnix) {
    result = "Unix";
  } else if (isLinux) {
    result = "Linux";
  } else if (isWin) {
    const isWin2K = userAgent.indexOf("Windows NT 5.0") > -1 || userAgent.indexOf("Windows 2000") > -1;
    const isWinXP = userAgent.indexOf("Windows NT 5.1") > -1 || userAgent.indexOf("Windows XP") > -1;
    const isWin2003 = userAgent.indexOf("Windows NT 5.2") > -1 || userAgent.indexOf("Windows 2003") > -1;
    const isWinVista = userAgent.indexOf("Windows NT 6.0") > -1 || userAgent.indexOf("Windows Vista") > -1;
    const isWin7 = userAgent.indexOf("Windows NT 6.1") > -1 || userAgent.indexOf("Windows 7") > -1;
    const isWin10 = userAgent.indexOf("Windows NT 10.0") > -1 || userAgent.indexOf("Windows 10") > -1;
    if (isWin2K) {
      result = "Win2000";
    } else if (isWinXP) {
      result = "WinXP";
    } else if (isWin2003) {
      result = "Win2003";
    } else if (isWinVista) {
      result = "WinVista";
    } else if (isWin7) {
      result = "Win7";
    } else if (isWin10) {
      result = "Win10";
    } else {
      result = "Windows";
    }
  } else {
    result = "other";
  }
  return result;
}
const setOriginUrlStorage = () => {
  localAESStorage.setItem("originURL", window.location.href);
  localStorage.setItem("originUrlCreateDate", new Date().toISOString());
};
// 更新本地存储的originUrl
const updateOriginUrl = () => {
  const originUrlCreateDate = localStorage.getItem("originUrlCreateDate");
  if (!originUrlCreateDate) {
    setOriginUrlStorage();
  } else {
    const currentTime = new Date().getTime();
    const storedTime = new Date(originUrlCreateDate).getTime();
    const timeDifference = currentTime - storedTime;
    if (timeDifference > 24 * 60 * 60 * 1000) {
      setOriginUrlStorage();
    }
  }
};
export function createBaiduChannel(searchStr) {
  const urlParams = new URLSearchParams(searchStr);
  const sourceParam = urlParams.get("source") != null ? urlParams.get("source") : "";
  const planParam = urlParams.get("plan") != null ? urlParams.get("plan") : "";
  updateOriginUrl();
  if (sourceParam && planParam) {
    localAESStorage.setItem("expandData", {
      source: sourceParam,
      plan: planParam
    });
  }
}
/**
 * [处理时间]
 *
 * @export
 */
export function formatUTCTimestamp() {
  const currentTimestamp = Date.now();
  const timezoneOffsetMinutes = new Date().getTimezoneOffset();
  const utcOffsetMilliseconds = timezoneOffsetMinutes * 60 * 1000;
  const utcTimestamp = currentTimestamp + utcOffsetMilliseconds;
  return utcTimestamp;
}